import type { RouteRecordRaw } from 'vue-router'

export const ucAdminRoutes: RouteRecordRaw[] = [
  {
    path: '/uc-admin/call-control-apps/automations',
    name: 'uc-automations',
    component: () => import('./automations/pages/AutomationsPage.vue')
  },
  {
    path: '/uc-admin/call-control-apps/automations/:id/edit',
    name: 'uc-automation-edit',
    component: () => import('./automations/pages/AutomationEditPage.vue'),
    props: true
  },
  {
    path: '/uc-admin/phone-numbers',
    name: 'uc-phone-numbers',
    component: () => import('./phone-numbers/pages/UcPhoneNumbersPage.vue')
  },
  {
    path: '/uc-admin/phone-numbers/:id/edit',
    name: 'uc-phone-number-edit',
    component: () => import('./phone-numbers/pages/UcPhoneNumberEditPage.vue'),
    props: true
  },
  {
    path: '/uc-admin/settings-and-security/music-on-hold',
    name: 'music-on-hold',
    component: () => import('./music-on-hold/pages/MusicOnHoldPage.vue')
  },
  {
    path: '/uc-admin/settings-and-security/music-on-hold/:id/edit',
    name: 'music-on-hold-edit',
    component: () => import('./music-on-hold/pages/MusicOnHoldEditPage.vue'),
    props: true
  },
  {
    path: '/uc-admin/settings-and-security/blocked-numbers',
    name: 'blocked-numbers',
    component: () => import('./blocked-numbers/pages/BlockedNumbersPage.vue')
  },
  {
    path: '/uc-admin/settings-and-security/captchas',
    name: 'captchas',
    component: () => import('./captchas/pages/CaptchasPage.vue')
  },
  {
    path: '/uc-admin/settings-and-security/captchas/:id/edit',
    name: 'captchas-edit',
    component: () => import('./captchas/pages/CaptchaEditPage.vue'),
    props: true
  },
  {
    path: '/uc-admin/settings-and-security/webhooks',
    name: 'webhooks',
    component: () => import('./webhooks/pages/WebhooksPage.vue')
  },
  {
    path: '/uc-admin/settings-and-security/webhooks/:id/edit',
    name: 'webhooks-edit',
    component: () => import('./webhooks/pages/WebhooksEditPage.vue'),
    props: true
  },
  {
    path: '/uc-admin/settings-and-security/recordings',
    name: 'recordings',
    component: () => import('./recordings/pages/RecordingsPage.vue')
  },
  {
    path: '/uc-admin/settings-and-security/recordings/:id/edit',
    name: 'recordings-edit',
    component: () => import('./recordings/pages/RecordingsEditPage.vue'),
    props: true
  },
  {
    path: '/uc-admin/call-flow/two-way-toggles',
    name: 'two-way-toggles',
    component: () => import('./two-way-toggles/pages/TwoWayTogglesPage.vue')
  },
  {
    path: '/uc-admin/call-flow/two-way-toggles/:id/edit',
    name: 'two-way-toggles-edit',
    component: () => import('./two-way-toggles/pages/TwoWayToggleEditPage.vue'),
    props: true
  },
  {
    path: '/uc-admin/call-flow/multiway-toggles',
    name: 'multiway-toggles',
    component: () => import('./multiway-toggles/pages/MultiwayTogglesPage.vue')
  },
  {
    path: '/uc-admin/call-flow/multiway-toggles/:id/edit',
    name: 'multiway-toggles-edit',
    component: () => import('./multiway-toggles/pages/MultiwayToggleEditPage.vue'),
    props: true
  },
  {
    path: '/uc-admin/call-flow/api-routers',
    name: 'api-routers',
    component: () => import('./api-routers/pages/ApiRoutersPage.vue')
  },
  {
    path: '/uc-admin/call-flow/api-routers/:id/edit',
    name: 'api-routers-edit',
    component: () => import('./api-routers/pages/ApiRouterEditPage.vue'),
    props: true
  },
  {
    path: '/uc-admin/call-flow/tag-routers',
    name: 'tag-routers',
    component: () => import('./tag-routers/pages/TagRoutersPage.vue')
  },
  {
    path: '/uc-admin/call-flow/tag-routers/:id/edit',
    name: 'tag-routers-edit',
    component: () => import('./tag-routers/pages/TagRouterEditPage.vue'),
    props: true
  },
  {
    path: '/uc-admin/call-flow/call-queues',
    name: 'call-queues',
    component: () => import('./call-queues/pages/CallQueuesPage.vue')
  },
  {
    path: '/uc-admin/call-flow/call-queues/:id/edit',
    name: 'call-queues-edit',
    component: () => import('./call-queues/pages/CallQueueEditPage.vue'),
    props: true
  },
  {
    path: '/uc-admin/settings-and-security/star-codes',
    name: 'star-codes',
    component: () => import('./star-codes/pages/StarCodesPage.vue')
  },
  {
    path: '/uc-admin/call-flow/ring-groups',
    name: 'ring-groups',
    component: () => import('./ring-groups/pages/RingGroupsPage.vue')
  },
  {
    path: '/uc-admin/call-flow/ring-groups/:id/edit',
    name: 'ring-groups-edit',
    component: () => import('./ring-groups/pages/RingGroupEditPage.vue'),
    props: true
  },
  {
    path: '/uc-admin/call-flow/ivr-menus',
    name: 'ivr-menus',
    component: () => import('./ivr-menus/pages/IvrMenusPage.vue')
  },
  {
    path: '/uc-admin/call-flow/ivr-menus/:id/edit',
    name: 'ivr-menus-edit',
    component: () => import('./ivr-menus/pages/IvrMenuEditPage.vue'),
    props: true
  },
  {
    path: '/uc-admin/call-flow/schedules',
    name: 'schedules',
    component: () => import('./schedules/pages/SchedulesPage.vue')
  },
  {
    path: '/uc-admin/call-flow/schedules/:id/edit',
    name: 'schedules-edit',
    component: () => import('./schedules/pages/ScheduleEditPage.vue'),
    props: true
  },
  {
    path: '/uc-admin/call-flow/vip-callers',
    name: 'vip-callers',
    component: () => import('./vip-callers/pages/VipCallersPage.vue')
  },
  {
    path: '/uc-admin/call-flow/vip-callers/:id/edit',
    name: 'vip-callers-edit',
    component: () => import('./vip-callers/pages/VipCallerEditPage.vue'),
    props: true
  },
  {
    path: '/uc-admin/extensions-and-devices/extensions',
    name: 'extensions',
    component: () => import('./extensions/pages/ExtensionsPage.vue')
  },
  {
    path: '/uc-admin/extensions-and-devices/extensions/:id/edit',
    name: 'extensions-edit',
    component: () => import('./extensions/pages/ExtensionsEditPage.vue'),
    props: true
  },
  {
    path: '/uc-admin/extensions-and-devices/phonebooks',
    name: 'phonebooks',
    component: () => import('./phonebooks/pages/PhonebooksPage.vue')
  },
  {
    path: '/uc-admin/extensions-and-devices/phonebooks/:id/edit',
    name: 'phonebooks-edit',
    component: () => import('./phonebooks/pages/PhonebookEditPage.vue'),
    props: true
  },
  {
    path: '/uc-admin/extensions-and-devices/provisioning-devices',
    name: 'provisioning-devices',
    component: () => import('./provisioning-devices/pages/ProvisioningDevicesPage.vue')
  },
  {
    path: '/uc-admin/extensions-and-devices/provisioning-devices/account',
    name: 'provisioning-devices-account',
    component: () => import('./provisioning-devices/pages/ProvisioningDevicesAccountPage.vue')
  },
  {
    path: '/uc-admin/extensions-and-devices/provisioning-devices/templates/:id/edit',
    name: 'provisioning-device-templates-edit',
    component: () => import('./provisioning-devices/pages/DeviceTemplateEditPage.vue'),
    props: true
  },
  {
    path: '/uc-admin/extensions-and-devices/provisioning-devices/templates/:id/keys/ext-panels/:panel/:page',
    name: 'provisioning-device-templates-ext-panel-keys-edit',
    component: () => import('./provisioning-devices/pages/DeviceKeysEditPage.vue'),
    props: true
  },
  {
    path: '/uc-admin/extensions-and-devices/provisioning-devices/templates/:id/keys/:type',
    name: 'provisioning-device-templates-keys-edit',
    component: () => import('./provisioning-devices/pages/DeviceKeysEditPage.vue'),
    props: true
  },
  {
    path: '/uc-admin/extensions-and-devices/provisioning-devices/devices/:id/edit',
    name: 'provisioning-devices-edit',
    component: () => import('./provisioning-devices/pages/DeviceEditPage.vue'),
    props: true
  },
  {
    path: '/uc-admin/extensions-and-devices/provisioning-devices/devices/:id/keys/ext-panels/:panel/:page',
    name: 'provisioning-devices-ext-panel-keys-edit',
    component: () => import('./provisioning-devices/pages/DeviceKeysEditPage.vue'),
    props: true
  },
  {
    path: '/uc-admin/extensions-and-devices/provisioning-devices/devices/:id/keys/:type',
    name: 'provisioning-devices-keys-edit',
    component: () => import('./provisioning-devices/pages/DeviceKeysEditPage.vue'),
    props: true
  },
  {
    path: '/uc-admin/call-control-apps/call-parking-lots',
    name: 'call-parking-lots',
    component: () => import('./call-parking-lots/pages/CallParkingLotsPage.vue')
  },
  {
    path: '/uc-admin/call-control-apps/call-parking-lots/:id/edit',
    name: 'call-parking-lots-edit',
    component: () => import('./call-parking-lots/pages/CallParkingLotEditPage.vue'),
    props: true
  },
  {
    path: '/uc-admin/call-control-apps/conference-bridges',
    name: 'conference-bridges',
    component: () => import('./conference-bridges/pages/ConferenceBridgesPage.vue')
  },
  {
    path: '/uc-admin/call-control-apps/conference-bridges/:id/edit',
    name: 'conference-bridges-edit',
    component: () => import('./conference-bridges/pages/ConferenceBridgeEditPage.vue'),
    props: true
  },
  {
    path: '/uc-admin/call-control-apps/directories',
    name: 'directories',
    component: () => import('./directories/pages/DirectoriesPage.vue')
  },
  {
    path: '/uc-admin/call-control-apps/directories/:id/edit',
    name: 'directories-edit',
    component: () => import('./directories/pages/DirectoryEditPage.vue'),
    props: true
  },
  {
    path: '/uc-admin/call-control-apps/forwarders',
    name: 'forwarders',
    component: () => import('./forwarders/pages/ForwardersPage.vue')
  },
  {
    path: '/uc-admin/call-control-apps/forwarders/:id/edit',
    name: 'forwarders-edit',
    component: () => import('./forwarders/pages/ForwarderEditPage.vue'),
    props: true
  },
  {
    path: '/uc-admin/call-control-apps/page-groups',
    name: 'page-groups',
    component: () => import('./page-groups/pages/PageGroupsPage.vue')
  },
  {
    path: '/uc-admin/call-control-apps/page-groups/:id/edit',
    name: 'page-groups-edit',
    component: () => import('./page-groups/pages/PageGroupEditPage.vue'),
    props: true
  },
  {
    path: '/uc-admin/call-control-apps/wakeup-calls',
    name: 'wakeup-calls',
    component: () => import('./wakeup-calls/pages/WakeupCallsPage.vue')
  }
]
